import React, {useEffect, useState, useRef} from 'react';
import {Card, Col, Row, Table, Pagination} from "react-bootstrap";
import styles from './admin-transfer-list.module.scss'
import {formatDateTime, toCurrency} from "../../../../helpr/helper";
import Loading from "../../../../components/loading/loading";
import detailsArrowIcon from "../../../../assets/table-details-arrow.svg";
import {
  TRANSFER_COMPLETED,
  TRANSFER_PENDING_CONFIRMATION,
  TRANSFER_PENDING_PDTC_PROCESSING,
  TRANSFER_PENDING_SUBMISSION, TRANSFER_REJECTED, TRANSFER_REJECTED_FOR_EDIT
} from "../../../../helpr/constants";
import usePagination from "../../../../hooks/use-pagination";
import paginationLeftIcon from "../../../../assets/pagination-arrow-left.svg";
import paginationRightIcon from "../../../../assets/pagination-arrow-right.svg";
import ModalCustom from "../../../../components/modal/modal";
import SecondaryMarketService from "../../../../services/secondary-market-service";
import Transfer from "../../../../models/transfer";
import AdminTransferDetailsModalContent
  from "./components/admin-transfer-details-modal-content/admin-transfer-details-modal-content";

const AdminTransferList = () => {
  //Set spinner state
  const [loading, setLoading] = useState(true);
  //Set transfer list state
  const [transferList, setTransferList] = useState([]);
  const selectedTransfer = useRef({});
  //Modal State
  const [showTransferDetailsModal, setShowTransferDetailsModal] = useState(false);
  //Page data
  const pagedData = usePagination(transferList,10);
  const pages = Array(pagedData.maxPage).fill().map((_, i) =>
    <Pagination.Item
      key={i+1}
      active={(i+1) === pagedData.currentPage}
      onClick={() => pagedData.jump(i+1)}>
      {i+1}
    </Pagination.Item>);
  //Initialize Service
  const secondaryMarketService = new SecondaryMarketService();
  //Table Headers
  const headers = [
    "Ref No.",
    "Broker",
    "Bond Holder",
    "Security Name",
    "Amount",
    "Last Update Date",
    "Status",
    ""
  ]

  useEffect(()=> {
    const retrieveTransfers = async () => {
      try {
        const result = await secondaryMarketService.getListOfTransfers()
        const transfersList = result.map(t => new Transfer(t));
        setTransferList(transfersList);
      } catch(error){

      } finally {
        setLoading(false);
      }

    }
    retrieveTransfers();
    // eslint-disable-next-line
  }, []);

  const showTransferDetails = (transfer) => {
    selectedTransfer.current = transfer;
    setShowTransferDetailsModal(true)
  }

  return loading ? <Loading /> : (
    <div className={styles['admin-transfer-list-table']}>
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h1>Transfers</h1>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Table responsive>
                    <thead>
                    <tr>
                      {headers.map(
                        (header, index) => {
                          return <th key={index}>{header}</th>
                        }
                      )}
                    </tr>
                    </thead>
                    <tbody>
                    {
                      pagedData.currentData().map((transfer, index) => {
                        return (
                          <tr key={index}>
                            <td>{transfer.transferId}</td>
                            <td>{transfer.brokerName}</td>
                            <td>{`${transfer.firstName} ${transfer.lastName}`}</td>
                            <td>{transfer.securityName}</td>
                            <td>{transfer.transferAmount ? toCurrency(transfer.transferAmount) : '-'}</td>
                            <td>{transfer.lastUpdatedDate}</td>
                            <td>{renderStatus(transfer.transferStatus)}</td>
                            <td className={styles['detail-arrow']} onClick={() => showTransferDetails(transfer)}>
                              <img alt="See Details" src={detailsArrowIcon} />
                            </td>
                          </tr>
                        )
                      })
                    }
                    </tbody>
                  </Table>
                  {
                    pagedData.maxPage > 0
                      ? <Pagination>
                        <Pagination.First
                          onClick={() => pagedData.jump(1)}
                          disabled={pagedData.currentPage === 1}>
                          <img alt="FIRST" src={paginationLeftIcon}/>
                        </Pagination.First>
                        <Pagination.Prev
                          onClick={() => pagedData.jump(pagedData.currentPage - 1)}
                          disabled={pagedData.currentPage === 1}>
                          PREV
                        </Pagination.Prev>
                        {pages}
                        <Pagination.Next
                          onClick={() => pagedData.jump(pagedData.currentPage + 1)}
                          disabled={pagedData.currentPage === pagedData.maxPage}>
                          NEXT
                        </Pagination.Next>
                        <Pagination.Last
                          onClick={() => pagedData.jump(pagedData.maxPage)}
                          disabled={pagedData.currentPage === pagedData.maxPage}>
                          <img alt="LAST" src={paginationRightIcon}/>
                        </Pagination.Last>
                      </Pagination> :
                      <div className={styles['no-data']}>No transfers to confirm.</div>
                  }
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ModalCustom
        show={showTransferDetailsModal}
        title="Transfer Details"
        onClose={() => setShowTransferDetailsModal(false)}
        component={<AdminTransferDetailsModalContent context={{selectedTransfer, setTransferList}} onClose={() => setShowTransferDetailsModal(false)} />}
        style={styles['admin-transfer-details-modal']} />
    </div>
  )
}

const renderStatus = (status) => {
  switch(status){
    case TRANSFER_PENDING_SUBMISSION:
      return 'Pending Submission'
    case TRANSFER_PENDING_CONFIRMATION:
      return 'Pending Confirmation'
    case TRANSFER_PENDING_PDTC_PROCESSING:
      return 'Pending for PDTC Processing'
    case TRANSFER_COMPLETED:
      return 'Completed'
    case TRANSFER_REJECTED:
      return 'Rejected'
    case TRANSFER_REJECTED_FOR_EDIT:
      return 'Rejected for Editing'
    default:
  }
}

export default AdminTransferList;
